<div class="information-bar-banner w-full block" *ngFor="let informationBar of informationBars" [@fade]="status">
    <input type="checkbox" class="hidden" id="bannerInformationBar">
    <div class="relative w-full p-4 shadow-sm text-gray-800 {{cssClass(informationBar)}} transition-all duration-200 ease-in-out">
      <!-- Close button - always top right -->
      <a class="close cursor-pointer absolute top-4 right-4 text-gray-600 p-1 rounded-full z-10" 
         (click)="removeInformationBar(informationBar)" 
         [hidden]="!informationBar.closeEnable"
         title="Fermer">
         <mat-icon svgIcon="heroicons_solid:x-mark" class="w-4 h-4"></mat-icon>
      </a>
      
      <!-- Content area with padding for close button -->
      <div class="flex flex-col sm:flex-row sm:items-center justify-between w-full pr-8 sm:pr-12">
        <div class="flex-1 min-w-0 mb-3 sm:mb-0 flex items-start">
          <!-- Optional icon -->
          <mat-icon *ngIf="informationBar.iconName" 
                    [svgIcon]="informationBar.iconName"
                    [class]="informationBar.iconColor || 'text-gray-600'"
                    class="w-5 h-5 mr-3 mt-0.5 flex-shrink-0">
          </mat-icon>
          <span class="text-sm sm:text-base leading-relaxed block text-gray-800">{{informationBar.message}}</span>
        </div>
        <div class="flex items-center justify-center sm:justify-end">
          <button *ngIf="informationBar.messageButton" 
                  color="primary" 
                  class="inline-flex items-center px-4 py-2 bg-gray-800 hover:bg-gray-900 text-white text-sm font-medium rounded-lg transition-all duration-200 ease-in-out hover:scale-105 active:scale-95 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2" 
                  (click)="informationBar.buttonClick()">
              {{informationBar.messageButton}}
          </button>
        </div>
      </div>
  </div>
</div>
  